import { breakpoints as bp } from '../settings.js';
import Swiper from 'swiper';
import { Navigation, EffectFade, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

function init () {
    const carouselEls = document.querySelectorAll('.js-carousel .swiper-container');
    for (const item of Array.from(carouselEls)) {
        if (window.innerWidth >= bp.md) {
            const swiper = new Swiper(item, {
                modules: [Navigation, EffectFade, Pagination],
                direction: 'horizontal',
                loop: false,
                speed: 600,
                slidesPerView: 3,
                spaceBetween: 30,
                slidesPerGroup: 3,
                watchOverflow: true,
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }
            });
        } else {
            const swiper = new Swiper(item, {
                modules: [Navigation, EffectFade, Pagination],
                direction: 'horizontal',
                loop: false,
                speed: 800,
                slidesPerView: 1,
                spaceBetween: 30,
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }
            });
        }
    }
}

export { init };